import { useEffect, useState } from "react";
import { KbvPluginService } from "@/services/kbvPluginService";
import { absUrl, useSiteOrigin } from "../useSiteOrigin";
import { useDesktop } from "../useDesktop";
import "./highlight-video.css";

function normalizeYoutubeId(rawId) {
  const value = String(rawId ?? "").trim();
  if (!value) return "";
  if (value.includes("youtube.com") || value.includes("youtu.be")) {
    try {
      const url = new URL(value);
      const fromQuery = url.searchParams.get("v");
      if (fromQuery) return fromQuery;
      const pathParts = url.pathname.split("/").filter(Boolean);
      return pathParts[pathParts.length - 1] ?? "";
    } catch {
      return value;
    }
  }
  return value.split("?")[0].split("&")[0].split("/")[0];
}

function getHighlightVideoId(item) {
  return normalizeYoutubeId(item?.videoId ?? item?.videoUrl ?? "");
}

function getCupLabel(leagueName) {
  const name = (leagueName ?? "").toLowerCase();
  if (!name) return "";
  if (name.includes("europa") || name.includes("eurol") || name.includes("c2")) {
    return "Cúp C2 Châu Âu";
  }
  if (name.includes("champions") || name.includes("ucl") || name.includes("c1")) {
    return "Cúp C1 Châu Âu";
  }
  if (name.includes("châu") || name.includes("chau")) return leagueName;
  return leagueName;
}

function HighlightVideoCard({ item, origin }) {
  const match = item?.match;
  const league = match?.league;
  const title = item?.title ?? "";
  const videoId = getHighlightVideoId(item);
  const href = absUrl(origin, `/xem-highlight/${encodeURIComponent(String(videoId ?? ""))}`);
  const thumbnailUrl = item?.thumbnailUrl ?? "";
  const cupLabel = getCupLabel(league?.name ?? "");

  return (
    <a className="kbv-highlight-video__item" href={href}>
      <article>
        <div className="kbv-highlight-video__thumb">
          {thumbnailUrl ? (
            <img src={thumbnailUrl} alt={title || "highlight"} loading="lazy" />
          ) : (
            <div className="kbv-highlight-video__thumb-fallback" />
          )}
          <div className="kbv-highlight-video__badge">
            <span aria-hidden>▶</span>
            <span>Highlight</span>
          </div>
        </div>
        <div className="kbv-highlight-video__body">
          <div className="kbv-highlight-video__item-title">{`KEOBONGVIP ${title}`}</div>
          {cupLabel ? (
            <div className="kbv-highlight-video__league">
              {league?.logo ? (
                <span className="kbv-highlight-video__league-logo">
                  <img src={league.logo} alt="" />
                </span>
              ) : null}
              <span>{cupLabel}</span>
            </div>
          ) : null}
        </div>
      </article>
    </a>
  );
}

export default function HighlightVideoSideBar() {
  const desktop = useDesktop();
  const origin = useSiteOrigin();
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!desktop) return undefined;
    let cancelled = false;
    setLoading(true);
    KbvPluginService.fetchHighlightVideos({ page: 1, limit: 5, hotTeam: 1 })
      .then((list) => {
        if (!cancelled) setVideos(Array.isArray(list) ? list : []);
      })
      .catch(() => {
        if (!cancelled) setVideos([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [desktop]);

  if (!desktop) return null;

  return (
    <aside className="kbv-home kbv-highlight-video" aria-label="Highlight video sidebar">
      <div className="kbv-highlight-video__card">
        <div className="kbv-highlight-video__head">
          <span className="kbv-highlight-video__title">Highlight video</span>
        </div>

        {loading ? (
          <div className="kbv-highlight-video__empty">Đang tải...</div>
        ) : videos.length ? (
          <div className="kbv-highlight-video__list">
            {videos.map((item, index) => (
              <HighlightVideoCard
                key={item?.id ?? item?.matchId ?? item?.videoId ?? index}
                item={item}
                origin={origin}
              />
            ))}
          </div>
        ) : (
          <div className="kbv-highlight-video__empty">Không có dữ liệu</div>
        )}

        <a className="kbv-highlight-video__more" href={absUrl(origin, "/xem-highlight")}>
          Xem tất cả
        </a>
      </div>
    </aside>
  );
}
